import React, { useEffect } from 'react';
import { Burger, Divider, Drawer } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';
import { useContent } from '@/providers/ContentProvider';
import { AppUser } from '@/types/user';
import { LanguageSelect } from './LanguageSelect';
import { NavLink } from '../../navlink/NavLink';
import { AppPaths } from '@/configs/appPaths';
import styles from '../Navbar.module.scss';

interface Props {
	baseSlug: string;
}

export const HamburgerMenu: React.FC<Props> = ({ baseSlug }) => {
	const { getContent } = useContent();

	const [opened, { toggle, close }] = useDisclosure(false);

	const { pathname } = useLocation();
	useEffect(() => {
		close();
	}, [pathname]);

	const { logout } = useAuth();
	const user = useAuth().user as AppUser;

	return (
		<div className={styles.mobileMenuContainer}>
			<Burger
				size="md"
				opened={opened}
				onClick={toggle}
				aria-label={opened ? 'Close navigation' : 'Open navigation'}
			/>
			<Drawer
				opened={opened}
				onClose={close}
				classNames={{ header: 'd-none' }}
				size="100%"
			>
				<nav className={styles.mobileMenu}>
					{!user && (
						<NavLink className={styles.item} to={AppPaths.LOGIN}>
							{getContent(`${baseSlug}login`)}
						</NavLink>
					)}

					{user && user.status === 'active' && (
						<NavLink className={styles.item} to={AppPaths.ORDERS} end>
							{getContent(`${baseSlug}orders`)}
						</NavLink>
					)}

					{user && user.status === 'active' && (
						<NavLink className={styles.item} to={AppPaths.OFFERS} end>
							{getContent(`${baseSlug}offers`)}
						</NavLink>
					)}

					{user && (
						<NavLink className={styles.item} to={AppPaths.COMPANY} end>
							{getContent(`${baseSlug}company`)}
						</NavLink>
					)}

					{user && (
						<NavLink className={styles.item} to={AppPaths.CLIENTS} end>
							Pracownicy
						</NavLink>
					)}
					{user && (
						<NavLink className={styles.item} to={AppPaths.CONTACTS} end>
							Kontakty
						</NavLink>
					)}

					{user && <Divider w="100%" my="sm" />}
					{user && (
						<NavLink className={styles.item} to={AppPaths.ACCOUNT} end>
							Twoje konto
						</NavLink>
					)}
					{user && (
						<NavLink to="" onClick={logout}>
							Wyloguj
						</NavLink>
					)}
					<LanguageSelect />
				</nav>
			</Drawer>
		</div>
	);
};
